module.exports = __webpack_public_path__ + "static/media/Company-Directory_Icon.1f40fc3d.svg";